export const FILTER_CHANGE_ON_CATEGORY = '@@filter/FILTER_CHANGE_ON_CATEGORY';
export const FILTER_SEARCH_BY_NAME_CHANGE = '@@filter/FILTER_SEARCH_BY_NAME_CHANGE';
